import Footer from '@/components/footer';
import Header from '@/components/header';
import { Toaster } from '@/components/ui/sonner';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="flex flex-col min-h-dvh w-full">
      <Header />
      <section className="flex flex-grow w-full flex-col items-center py-4">
        <Outlet />
      </section>
      <Footer />
      <Toaster />
    </section>
  );
}
